import React from 'react';
import { LogoIcons } from '~/components/icons';
export const UnsplashIcon = React.memo(() => {
    return React.createElement("img", { style: { width: 14, height: 14 }, src: LogoIcons.unsplashWhite, alt: 'unsplash' });
});
